import { useRecoilState, useRecoilValue } from "recoil";
import ToggleSwitch from "src/common/components/toggleSwitch";
import { PriceChangeEnum } from "src/constants/enums/priceChange";
import { ISelection } from "src/constants/interfaces/bet";
import { useConfig } from "src/hooks/config";
import { useTranslation } from "src/hooks/translation";
import mainStore from "src/stores/main";
import { useEffect, useState } from "react";
import upperDataStore from "src/stores/upperData";
import { storeChangeSelection } from "src/stores/selections";
import { getCounterOfferMaxOdd } from "src/rules/calculation/odd";
import { decimalString } from "src/constants/types";
import OddInput from "src/common/components/oddInput";
import { counterOfferAvailable } from "src/rules/counterOffer";

import "./style.scss";

interface IProps {
	selection: ISelection;
}

const CounterOfferToggle = ({ selection }: IProps) => {
	const t = useTranslation();
	const [value, setValue] = useState<decimalString>("");
	const config = useConfig();
	const { partnerConfig } = useRecoilValue(upperDataStore);

	const mainState = useRecoilValue(mainStore);
	const toggleEnabled = selection.priceChangeType === PriceChangeEnum.CounterOffer;
	const { alternateOdd } = selection;
	const isCounterOfferAvailbale = counterOfferAvailable(config, mainState, partnerConfig, selection);

	useEffect(() => {
		setValue((alternateOdd || '').toString() as decimalString);
	}, [alternateOdd]);

	const toggleCounterOFfer = () => {
		storeChangeSelection(selection.event.id, {
			...selection,
			alternateOdd: 0,
			priceChangeType:
				selection.priceChangeType !== PriceChangeEnum.CounterOffer
					? PriceChangeEnum.CounterOffer
					: null,
		});
	};

	const inputChange = (value: decimalString) => {
		if (!value) {
			storeChangeSelection(selection.event.id, { ...selection, alternateOdd: 0 });
		}
		setValue(value);
		storeChangeSelection(selection.event.id, { ...selection, alternateOdd: !isNaN(+value) ? +value : 0 });
	};

	const maxButton = () => {
		const maxOdd = partnerConfig && getCounterOfferMaxOdd(partnerConfig, selection);

		if (maxOdd) {
			storeChangeSelection(selection.event.id, { ...selection, alternateOdd: +maxOdd });
			setValue(`${maxOdd}`);
		}
	};

	if (!isCounterOfferAvailbale) return null;

	return (
		<>
			{toggleEnabled && (
				<div className="B-counter-offer-odd-input-wrp">
					<OddInput value={value} onChange={inputChange} onMaxClick={maxButton} />
				</div>
			)}

			<div className="B-counter-offer-toggle">
				<i className="icon icon-rocket" />
				<p>{t("Request higher odd")}</p>

				<ToggleSwitch onChange={toggleCounterOFfer} checked={toggleEnabled} />
			</div>
		</>
	);
};

export default CounterOfferToggle;
